import React from 'react';
import { SortableContainer as Container } from 'react-sortable-hoc';
export const SortableContainer = Container(({ children, className }) =>
    <div className={`${className} sort-container`}>
    {children}
    </div>)